export function getColor() {
    return ""
}
